import CollapsibleContainer from 'components/customComponents/CommonComponents/CollapsibleContainer';
import NodesGroupView from 'components/customComponents/TreeControl/NodesGroupView/NodesGroupView';
import ETreeGroupTypes from 'enums/ETreeGroupTypes';
import EViewType from 'enums/EViewType';
import React from 'react';
import './Styles.scss';
import { TreeNodeTypeNames } from 'enums/ETreeNodeTypes';
import { TreeNodeDTO } from 'business/models/Models';
import NodeDetailView from 'components/customComponents/TreeControl/NodeDetailView';
interface TreeNodesContainerProps {
  treeNodes: any;
  selectedNodes: any[];
  viewType: EViewType;
  groupBy: ETreeGroupTypes;
  nodeClickHandler: (
    link: any,
    node: any,
    id: any,
    expanded: any,
    inputNodeName: any,
  ) => void;
  loadImageIcon;
  selectedExplorerNode: TreeNodeDTO | null;
}
function TreeNodesContainer(props: TreeNodesContainerProps) {
  const {
    treeNodes,
    selectedNodes,
    viewType = EViewType.ListView,
    groupBy = ETreeGroupTypes.None,
    nodeClickHandler,
    loadImageIcon,
    selectedExplorerNode,
  } = props;

  const renderListView = () => {
    return Object.keys(treeNodes).map((item, index) => {
      return (
        <CollapsibleContainer
          key={'tree-nodes-category-container' + index}
          title={`${TreeNodeTypeNames[treeNodes[item]?.category]}s (${
            treeNodes[item]?.data?.length
          })`}
          mainContainerClass={'tree-nodes-main-container'}
          disableCollapse={groupBy === ETreeGroupTypes.None}
        >
          <NodesGroupView
            viewType={viewType}
            selectedNodes={selectedNodes}
            childTreeNodes={treeNodes[item]?.data}
            nodeClickHandler={nodeClickHandler}
            loadImageIcon={loadImageIcon}
            selectedExplorerNode={selectedExplorerNode}
          />
        </CollapsibleContainer>
      );
    });
  };

  const renderDetailView = () => {
    return (
      <NodeDetailView
        key="node-detail-view"
        treeNodes={treeNodes}
        groupBy={groupBy}
        nodeClickHandler={nodeClickHandler}
        selectedNodes={selectedNodes}
        selectedExplorerNode={selectedExplorerNode}
        loadImageIcon={loadImageIcon}
        viewType={viewType}
      />
    );
  };
  const renderNodes = () => {
    if (viewType === EViewType.DetailView) {
      return renderDetailView();
    }
    return renderListView();
  };

  return <>{renderNodes()}</>;
}

export default TreeNodesContainer;
